<template>
  <header class="relative flex min-h-svh bg-theme-200 pt-navbar-height sm:min-h-[45vh]">
    <!-- LOGO -->
    <NuxtLink
      :to="topLevelEntry.url"
      :aria-label="$t('aria_labels.home')"
      class="absolute left-container top-10 z-30 lg:left-container-desktop md:left-container-lg"
    >
      <IconLogo class="h-5 sm:h-7" :class="data.is_independent ? 'text-white': 'text-blue-500'" />
    </NuxtLink>

    <Container v-animate-children-in-from-bottom class="w-full" indent="default-but-on-mobile-lg">
      <div class="grid h-full max-w-container-max py-14 lg:grid-cols-2">
        <div class="mr-[10%] flex flex-col justify-between">
          <!-- SURTITLE -->
          <p class="typo-label-md md:mt-2 md:typo-label-lg">
            {{ data.surtitle || data.parent?.title }}
          </p>

          <!-- TITLE -->
          <h1
            v-if="data.heading"
            class="mt-32 typo-heading-xl lg:mb-26 lg:mt-16 md:text-heading-2xl md:typo-display-lg"
            v-html="data.heading"
          />

          <!-- BACK LINK DESKTOP -->
          <BackLink
            class="mt-auto max-lg:hidden"
            :to="data.parent?.url"
          />
        </div>

        <!-- TEXT -->
        <div v-if="data.text" class="mb-3 h-fit grow-0 border-b max-lg:mt-8 md:border-b-2">
          <div
            class="pb-[1.75em] typo-body-xl md:typo-body-4xl"
            v-html="data.text"
          />
        </div>

        <!-- BACK LINK MOBILE -->
        <div class="mt-auto">
          <BackLink
            class="mt-10 lg:hidden md:mt-16"
            :to="data.parent?.url"
          />
        </div>
      </div>
    </Container>
  </header>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
})

// Since the collection allows only one level deep, use parent if it exists, otherwise use entry
const topLevelEntry = computed(() => props.data?.parent || props.data)
</script>
